export default "__VITE_ASSET__CsYVntmG__"